import React from "react";
import { withSize } from "react-sizeme";
import ConditionalWrapper from "../ConditionalWrapper";
function ChildComponent(_ref) {
  var children = _ref.children,
    hasSpanWrapper = _ref.hasSpanWrapper;
  return /*#__PURE__*/React.createElement(ConditionalWrapper, {
    condition: !!hasSpanWrapper,
    wrapper: function wrapper(childElement) {
      return /*#__PURE__*/React.createElement("div", null, childElement);
    }
  }, children);
}
var ChildComponentWithSize = withSize({
  monitorHeight: true,
  noPlaceholder: true
})(ChildComponent);
var ResizeDetector = function ResizeDetector(_ref2) {
  var setWidth = _ref2.setWidth,
    setHeight = _ref2.setHeight,
    onChange = _ref2.onChange,
    hasSpanWrapper = _ref2.hasSpanWrapper,
    children = _ref2.children;
  var onSize = function onSize(size) {
    if (size.width && setWidth) {
      setWidth(size.width);
    }
    if (size.height && setHeight) {
      setHeight(size.height);
    }
    if (onChange) {
      onChange();
    }
  };
  return /*#__PURE__*/React.createElement(ChildComponentWithSize, {
    onSize: onSize,
    hasSpanWrapper: hasSpanWrapper
  }, children);
};
export default ResizeDetector;